import $ from "jquery";
import "core-js/es/promise";
import "bootstrap";
import "../_imports/datatables/index";
import 'moment/locale/it';

$.ajaxSetup({
    headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
});